import React from 'react';
import {Header} from 'semantic-ui-react';

const LIMIT_TITLE_STR = 35;
const LIMIT_CONTENT_STR = 200;

const sliceText = (str, limitStr) => `${str.slice(0, limitStr)}`;
const addDots = (str, limitStr) => `${str.length >= limitStr ? `${sliceText(str, limitStr)}...` : str}`;

const CardSearch = ({title, id, text, handleClick, delear, date, responsible, repairDate}) => {
  const repairText = repairDate !== '' ? `FR: ${repairDate}` : '';
  return (
    <div className='container__card_search' onClick={handleClick}>
      <div className='row__card_search'>
        <Header as='h3'>{addDots(title, LIMIT_TITLE_STR)}</Header>
        <p className='budget'>{id}</p>
      </div>
      <p className='cause__card_search'>{addDots(text, LIMIT_CONTENT_STR)}</p>
      <div className='row__card_search'>
        <p className='delear'> {delear}</p>
        <p>FC: {date}</p>
      </div>
      <div className='row__card_search'>
        <p className='delear'>{responsible}</p>
        <p>{repairText}</p>
      </div>
    </div>
  );
};

export default CardSearch;
